export default "__VITE_ASSET__BzofSvG2__"